import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'
import Common from './common'

const commonApi = {
    state: {},
    mutations: {
        getBannerList(state, data) {
            data.url = API.website.bannerList
            CommonUtils.GetRequest(data)
        },
        getBannerOperate(state, data) {
            data.url = API.website.bannerDetail
            CommonUtils.GetRequest(data)
        },
        addBanner(state, data) {
            data.url = API.website.addBanner
            CommonUtils.PostRequest(data)
        },
        editBanner(state, data) {
            data.url = API.website.editBanner
            CommonUtils.PostRequest(data)
        },
        setBannerStatus(state, data) {
            data.url = API.website.setBannerStatus
            CommonUtils.PostRequest(data)
        },
        getWebsiteCateList(state, data) {
            data.url = API.website.websiteCateList
            CommonUtils.GetRequest(data)
        },
        addCate(state, data) {
            data.url = API.website.addCate
            CommonUtils.PostRequest(data)
        },
        editCate(state, data) {
            data.url = API.website.editCate
            CommonUtils.PostRequest(data)
        },
        setCateStatus(state, data) {
            data.url = API.website.setCateStatus
            CommonUtils.PostRequest(data)
        },
        getWebsiteCateDetail(state, data) {
            data.url = API.website.websiteCateDetail
            CommonUtils.GetRequest(data)
        },
        getCpsList(state, data) {
            data.url = API.website.getCpsInfo
            CommonUtils.GetRequest(data)
        },
        releaseProduct(state, data) {
            data.url = API.website.releaseProduct
            CommonUtils.PostRequest(data)
        },
        getCateList(state, data) {
            data.url = API.website.cateList
            CommonUtils.GetRequest(data)
        },
        getReleaseProductDetail(state, data) {
            data.url = API.website.releaseProductDetail
            CommonUtils.GetRequest(data)
        },
        getProductDisplayConfigs(state, data) {
            data.url = API.website.productDisplayConfigs
            CommonUtils.GetRequest(data)
        },
        getChannelSettingRule(state, data) {
            data.url = API.website.productConfigRule
            CommonUtils.GetRequest(data)
        },
        setDisplayRuleOpenOrClose(state, data) {
            data.url = API.website.setDisplayRuleOpenOrClose
            CommonUtils.PostRequest(data)
        },
        setChannelTag(state, data) {
            data.url = API.website.setChannelTag
            CommonUtils.PostRequest(data, true)
        },
        websiteSettingSave(state, data) {
            data.url = API.website.saveWebsiteSetting
            CommonUtils.PostRequest(data, true)
        },
        getWebsiteSettingInfo(state, data) {
            data.url = API.website.getWebsiteSettingInfo
            CommonUtils.GetRequest(data)
        }
    }
}

export default commonApi



// WEBPACK FOOTER //
// ./src/store/modules/website.js